const PRO_FORMAT_TYPES_LIST_DATA = {
  titleData: {
    textList: [
      {
        id: 1,
        text: 'your pro & broadcast formats',
        textMob: 'PRO FORMAT TAPES',
        secondText: 'Identifying your',
        secondTextMob: 'Identifying your',
        isTextReverse: true,
        isTextReverseMob: true,
        isTextColumn: true,
        isTextColumnMob: true,
        isLeft: false,
        isLeftMob: false,
        isRight: false,
        isRightMob: false,
        color: '#fff',
        colorMob: '#fff',
        isTextWithLine: false,
        isTextWithLineMob: false,
        isSecondTextWithLine: true,
        isSecondTextWithLineMob: false,
        firstTextLines: [],
        secondTextLines: [
          {
            id: 1,
            isLeftLine: false,
            isRightLine: true,
            isTopLine: false,
            isBottomLine: false,
            color: '#fff',
            isLineWithSquare: true,
            isLeftLineMob: false,
            isRightLineMob: true,
            isTopLineMob: false,
            isBottomLineMob: false,
            colorMob: '#fff',
            isLineWithSquareMob: true,
          },
        ],
      },
    ],
  },
  typesList: [
    {
      id: 1,
      title: 'Beta CAM',
      description: 'Professional video cassette format introduced by Sony in 1982, widely used in broadcast production.',
      descriptionMob: 'Professional video cassette format introduced by Sony in 1982, widely used in broadcast production for many years.',
      image: '',
    },
    {
      id: 2,
      title: 'Umatic',
      description: '¾-inch professional video cassette system introduced by Sony in 1971, adopted in TV stations and education.',
      descriptionMob: '¾-inch professional video cassette system introduced by Sony in 1971, adopted in TV stations and educational institutions.',
      image: '',
    },
    {
      id: 3,
      title: 'DVC PRO',
      description: 'Digital video tape format introduced by Panasonic in 1995, used in broadcast news and professional production.',
      descriptionMob: 'Digital video tape format introduced by Panasonic in 1995, used in broadcast news and professional production.',
      image: '',
    },
    {
      id: 4,
      title: 'DV CAM',
      description: 'Digital video format introduced by Sony in 1996, designed for pro camcorders and editing systems.',
      descriptionMob: 'Digital video format introduced by Sony in 1996, designed for professional camcorders and editing systems.',
      image: '',
    },
  ],
};

export default PRO_FORMAT_TYPES_LIST_DATA;
